import UserBus from '../buses/userBus'
import SnackBus from '../buses/snackBus'
import { getCookie } from '../helpers'
import { requestErrorMessage } from '../constants/errors'

export default (to, from, next) => {
    // if token not avail - send to auth check to check / set http cookie
    if (getCookie(UserBus.authCookieName) === '') {
        window.location.href = process.env.VUE_APP_AUTH_CHECK_URL
        return false
    }

    // validate token
    return UserBus.validateUser()
        .then(res => {
            // check if corporate user
            if (UserBus.userIs.corpUser()) {
                next()
            } else {
                // authenticated, but not corp user - send to search view
                next('/')
            }
        })
        .catch(err => {
            // if error is a 401, redirect user
            if (err && err.status === 401) {
                window.location.href = 'https://projectcenter.garlandhq.com'
            } else {
                // show error message for any other errors
                SnackBus.showMessage(requestErrorMessage, 'error')
            }
        })
}
